import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CookieConsentService } from '@core/services';

import type { NavItem } from '../../models';

interface FooterNavGroup {
  readonly title: string;
  readonly links: readonly NavItem[];
  readonly showCookiePreferences?: boolean;
}

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly consent = inject(CookieConsentService);

  openCookiePreferences(): void {
    this.consent.requestReopen();
  }

  protected readonly footerNavGroups: readonly FooterNavGroup[] = [
    {
      title: 'EVRN',
      links: [
        { label: 'Product', type: 'internal', routerLink: '/', fragment: 'product' },
        { label: 'Plans', type: 'internal', routerLink: '/plans' },
        { label: 'Demo', type: 'internal', routerLink: '/demo' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'Origin', type: 'internal', routerLink: '/origin' },
        { label: 'Contact', type: 'internal', routerLink: '/contact' },
      ],
    },
    {
      title: 'Resources',
      showCookiePreferences: true,
      links: [
        { label: 'FAQ', type: 'internal', routerLink: '/', fragment: 'faq' },
        { label: 'Terms & Conditions', type: 'internal', routerLink: '/terms-and-conditions' },
        { label: 'Privacy Policy', type: 'internal', routerLink: '/privacy-policy' },
      ],
    },
  ];

  protected readonly socialLinks: readonly NavItem[] = [
    {
      label: 'X',
      type: 'external',
      target: '_blank',
      href: 'https://x.com/evrn_world',
    },
    {
      label: 'Discord',
      type: 'external',
      target: '_blank',
      href: 'https://discord.com/invite/eBGr5Vzsyk',
    },
    {
      label: 'Instagram',
      type: 'external',
      target: '_blank',
      href: 'https://www.instagram.com/evrn_world/',
    },
    {
      label: 'LinkedIn',
      type: 'external',
      target: '_blank',
      href: 'https://www.linkedin.com/company/evrn-world',
    },
    {
      label: 'YouTube',
      type: 'external',
      target: '_blank',
      href: 'https://www.youtube.com/@EVRN_world',
    },
  ];
}
